import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
    *{
        z-index: 1000;
        box-sizing: border box;
        margin: 0;
        padding: 0;
    }
`
